import Header from "../Header";
import Footer from "../Footer";

const PublicLayout = ({ balance, account, setAccount, setBalance, hasBack, user1, gameId, midComponents, children }) => {
  return (
    <div className="container-public">
      <Header
        balance={balance}
        account={account}
        midComponents={midComponents || null}
        setAccount={setAccount}
        setBalance={setBalance}
      />
      {children}
      <Footer />
    </div>
  )
}

export default PublicLayout
